import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SitesService } from 'src/app/modules/shared/services/sites.service';
import { DataService } from 'src/app/modules/shared/services/data.service';
import { AuthenticationService } from 'src/app/modules/shared/services/authentication.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { DashboardUtils } from 'src/app/modules/shared/DashboardUtils';
import { timer, Subscription } from 'rxjs';
import { environment } from '../../../../../environments/environment';

@Component({
    selector: 'app-dashboard-site-grupo-caldeira-page',
    templateUrl: './dashboard-site-grupo-caldeira-page.component.html',
    styleUrls: ['./dashboard-site-grupo-caldeira-page.component.css']
})
export class DashboardSiteGrupoCaldeiraPageComponent implements OnInit, OnDestroy {

    public site: any;
    public realTimeCards: any[];
    public charts: any[];
    private refreshCardDataSubscription: Subscription;
    private refreshChartDataSubscription: Subscription;

    constructor(private route: ActivatedRoute, public authenticationService: AuthenticationService, private sitesService: SitesService, private dataService: DataService,
        private spinner: NgxSpinnerService) {
        this.realTimeCards = [];
        this.charts = [];
    }

    ngOnInit() {
        this.route.params.subscribe(params => {
            this.spinner.show();
            this.sitesService.get(params['id']).subscribe(response => {
                this.site = response;

                var grupoCaldeiras = this.site.grupoCaldeiras[0];

                // 1. Card de Geração de Vapor
                if (grupoCaldeiras.tagGeracaoVapor && grupoCaldeiras.tagGeracaoVapor.tagRealTimeValue) {
                    let cardGeracaoVapor = { tags: [], getIconClass: () => "image-caldeira-on", iconWidth: "25px", getLabel: () => 'GERAÇÃO DE VAPOR', getValue: () => { } };
                    cardGeracaoVapor.tags.push({ tag: grupoCaldeiras.tagGeracaoVapor.tagRealTimeValue });
                    cardGeracaoVapor.getValue = () => !isNaN(cardGeracaoVapor.tags[0].value) ? (cardGeracaoVapor.tags[0].value.toFixed(1) == -0 ? "0,0T/h" : cardGeracaoVapor.tags[0].value.toFixed(1).replace(/[.]/, ",") + "T/h") : "-";
                    this.realTimeCards.push(cardGeracaoVapor);
                }

                // 2. Cards de Status das Caldeiras
                grupoCaldeiras.caldeiras.forEach((caldeira, index) => {
                    let iconsByStatus = {};
                    iconsByStatus['0'] = "image-caldeira-off";
                    iconsByStatus['1'] = "image-caldeira-on";
                    iconsByStatus['2'] = "image-caldeira-alarm";
                    iconsByStatus['3'] = "image-caldeira-off";
                    iconsByStatus['4'] = "image-caldeira-off";

                    let cardCaldeira = { tags: [], getIconClass: () => iconsByStatus[cardCaldeira.tags[0].value] ? iconsByStatus[cardCaldeira.tags[0].value] : 'image-caldeira-off', iconWidth: "25px", getLabel: () => caldeira.name, getValue: () => { } };
                    cardCaldeira.tags.push({ tag: caldeira.tagStatus.tagRealTimeValue });
                    cardCaldeira.getValue = () => "";
                    this.realTimeCards.push(cardCaldeira);
                });

                // 1. Gráfico de Geração de Vapor
                if (grupoCaldeiras.tagGeracaoVapor && grupoCaldeiras.tagGeracaoVapor.tagHistoricalValues) {
                    let chartGeracaoVapor = DashboardUtils.buildDefaultChart("Geração de Vapor (T/h)", grupoCaldeiras.tagGeracaoVapor);
                    this.updateChart(chartGeracaoVapor);
                    this.charts.push(chartGeracaoVapor);
                }

                this.refreshCardDataSubscription = timer(0, environment.dashboard.cardUpdatePeriodSeconds * 1000).subscribe(result => {
                    this.refreshCardData();
                });
                this.refreshChartDataSubscription = timer(0, environment.dashboard.chartUpdatePeriodSeconds * 1000).subscribe(result => {
                    this.refreshChartData();
                });
                this.spinner.hide();
            });
        });
    };

    ngOnDestroy() {
        if (this.refreshCardDataSubscription) this.refreshCardDataSubscription.unsubscribe();
        if (this.refreshChartDataSubscription) this.refreshChartDataSubscription.unsubscribe();
    };

    refreshCardData() {
        var tags = [];
        this.realTimeCards.forEach(c => tags = tags.concat(c.tags));
        this.dataService.read({ items: tags }).subscribe(response => {
            for (let i in response.data) {
                Object.assign(tags[i], response.data[i]);
            }
        });
    };

    refreshChartData() {
        this.charts.forEach(chart => {
            this.updateChart(chart);
        });
    };

    updateChart(chartToUpdate) {
        DashboardUtils.updateChart(this.dataService, chartToUpdate);
    };
}
